// extracted by mini-css-extract-plugin
module.exports = {"mask":"UserModal_mask__ToAw3","modal":"UserModal_modal__31PVe","wallet":"UserModal_wallet__trexc","equity":"UserModal_equity__stuDN","equityIcon":"UserModal_equityIcon__BlBK3"};